import { AlertCircle } from "lucide-react";

import style from "./PCRSStatusBar.module.css";

// Top-of-screen PCRS bar. Always rendered so the "View PCRS details" action has
// a stable home; when the scheme check failed it also surfaces the error so the
// PCRS integration problem is visible without blocking the rest of the screen.
export const PCRSStatusBar = ({ title, message, action }) => {
  const hasError = !!title || !!message;

  return (
    <div
      className={`${style.bar} ${hasError ? style.error : ""}`.trim()}
      role={hasError ? "alert" : undefined}
    >
      {hasError && (
        <div className={style.content}>
          <AlertCircle size={20} className={style.icon} />
          <div className={style.text}>
            {!!title && <p className={style.title}>{title}</p>}
            {!!message && <p className={style.message}>{message}</p>}
          </div>
        </div>
      )}
      {!!action && <div className={style.action}>{action}</div>}
    </div>
  );
};
